import { createApp } from "vue";

import App from "./App.vue";
import { router } from "./router.js";

router.beforeEach((to, from, next) => {
    document.title = to.meta?.title ? `${to.meta.title} | InovaHC` : "InovaHC";
    next();
});

import { createPinia } from "pinia";
import print from "vue3-print-nb";
import vClickout from "vue3-clickout";
import moment from "moment-timezone";

import { configure } from "vue-gtag";

moment.tz.setDefault("America/Sao_Paulo").locale("pt-br");

const baseUrl = `${process.env.VUE_APP_API_URL}`;
const onlyBaseUrl = `${process.env.VUE_APP_ONLY_URL}`;

import "./style.css";

const app = createApp(App);

app.config.globalProperties.$moment = moment;
app.config.globalProperties.$baseUrl = baseUrl;
app.config.globalProperties.$onlyBaseUrl = onlyBaseUrl;

configure({
    tagId: "G-H7ESQZPM1R",
    initMode: "manual",
    pageTracker: {
        router,
        useScreenview: true
    }
})

app.use(createPinia());
app.use(router);
app.use(print);
app.use(vClickout);
app.mount("#app");
